const mime = require('mime-types');

const FILE_EXTENSIONS = ['.png', '.jpg', '.pdf', '.docx', '.xsl'];
const EXTENSIONS_MAPPER = FILE_EXTENSIONS.reduce(
  (map, extension) => ({
    ...map,
    [extension]: mime.lookup(extension),
  }),
  {},
);

module.exports = {
  EXTENSIONS_MAPPER,
  FILE_EXTENSIONS,
};
